import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ReactPaginate from "react-paginate";
import styles from "./styles/UserTable.module.css";
import UserModal from "./UserModal";

const UserTable = ({ data, schools, anon }) => {
  // PAGINATION

  const [userSlices, setUserSlices] = useState([[]]);
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    if (typeof data !== "undefined" && data.length !== 0) {
      const perPage = 20;
      const slices = [];
      const userCopy = [...data];
      while (userCopy.length) slices.push(userCopy.splice(0, perPage));
      setUserSlices(slices);
    }
  }, [data]);

  const handleChangePage = (userData) => {
    setPageNumber(userData.selected);
  };
  // ///////////////////////////////////////////////////////

  // OPEN MODAL
  const [showModal, setShowModal] = useState(false);
  const [user, setUser] = useState({});

  // //////////////////////////////
  return (
    <div>
      <div className="table-responsive">
        <table className="table table-striped table-sm">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Type</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody className={styles.tableBody}>
            {userSlices[pageNumber].map((userData) => {
              const created = new Date(userData.createdAt.replace(/-/g, "/"));
              return (
                <tr
                  className={styles.tableRow}
                  onClick={() => {
                    setUser(userData);
                    setShowModal(true);
                  }}
                  key={userData.userId}
                >
                  <td>{userData.userId}</td>
                  <td>
                    {anon
                      ? "**********"
                      : `${userData.fname} ${userData.lname}`}
                  </td>
                  <td>{anon ? "**********@********" : userData.email}</td>
                  <td>{userData.roleName}</td>
                  <td>{`${created.toLocaleDateString()} - ${created.toLocaleTimeString()}`}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {userSlices.length > 1 && (
        <ReactPaginate
          previousLabel="&laquo;"
          nextLabel="&raquo;"
          breakLabel="..."
          breakClassName="page-item"
          pageCount={userSlices.length}
          breakLinkClassName="page-link"
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          containerClassName="pagination"
          subContainerClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          nextClassName="page-item"
          previousLinkClassName="page-link"
          nextLinkClassName="page-link"
          activeClassName="page-item active"
          disabledClassName="page-item disabled"
          onPageChange={handleChangePage}
        />
      )}
      {showModal && (
        <UserModal
          show={showModal}
          onHide={() => setShowModal(false)}
          userData={user}
          schools={schools}
          anon={anon}
        />
      )}
    </div>
  );
};

UserTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  schools: PropTypes.arrayOf(PropTypes.object),
  anon: PropTypes.bool,
};

UserTable.defaultProps = {
  data: [],
  schools: [],
  anon: false,
};

export default UserTable;
